import { useEffect } from 'react';
import type { FC } from 'react';

import { rawTrackEngagementEvent } from '../../services/tracking/pulse';

import { AccountSharingPopup as VGAccountSharingPopup } from './VG/AccountSharingPopup';
import { AccountSharingPopup as ABAccountSharingPopup } from './AB/AccountSharingPopup';

export interface AccountSharingPopupProps {
  isOpen: boolean;
  variant: 'vg' | 'ab';
}

export const AccountSharingPopup: FC<AccountSharingPopupProps> = ({
  isOpen,
  variant,
}) => {
  const Component =
    variant === 'vg' ? VGAccountSharingPopup : ABAccountSharingPopup;

  useEffect(() => {
    if (isOpen) {
      rawTrackEngagementEvent({
        intent: 'View',
        object: {
          type: 'UIElement',
          id: 'account-sharing-popup',
        },
      });
    }
  }, [isOpen]);

  return <Component isOpen={isOpen} />;
};
